import React, { lazy, Component, Fragment, Suspense } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import {
  changePropertyId,
  changePropertyName,
  changeDomain,
  changeAvatarClick,
  changeBotActivation,
  changeGroupId,
  changeGroupName,
  changeLevel,
  setIsGroupButton,
  change_Integration_Channel,
  change_Chat_Started,
  changeCurrency,
  changeMode,
} from "./redux/actions";
import "./MsgWindow.css";
import ChatBot from "./Component/ChatBot";
import moment from "moment";
import Language from "./Data/Language";
const publicIp = require("public-ip");
const Bubble = lazy(() => import("./MsgBubbleComponent/Bubble"));
const MsgWindow = lazy(() => import("./MsgWindow"));
const BFF_API_URL = process.env.REACT_APP_BFF_API_URL;
const PAGE_VISIT_URL = process.env.REACT_APP_API_URL + "/pageLoaded";
const MESSENGER_CLICKS = process.env.REACT_APP_API_URL + "/messengerclick";
const PROPERTIES_URL = process.env.REACT_APP_API_URL + "/properties-by-group";
const GROUP_URL = process.env.REACT_APP_API_URL + "/group";
const api_ADD_MESSENGER_CLICK =
  process.env.REACT_APP_BFF_API_URL + "/public/messenger/stats";
const BMB_INTEGRATION =
  process.env.REACT_APP_BFF_API_URL + "/public/integrations/helpcenter";

const MESSENGER_URL = process.env.REACT_APP_API_URL + "/searchallmessenger";
const BMB_Group_INTEGRATION = process.env.REACT_APP_API_URL + "/getbyChannel";
const MESSENGER_CATEGORIES_URL =
  process.env.REACT_APP_API_URL + "/searchallcategories";
class MsgApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatBindings: {
        getGID: () => {
          return this.props.gid;
        },
        getIID: () => {
          return this.props.iid;
        },
        getPID: () => {
          return this.props.pid;
        },
        getAgentId: () => {
          return this.state.agentId;
        },
        getBotSettings: () => {
          return this.state.botSettings;
        },
      },
    };
    const iid = props.iid;
    const lStore = {
      OPENED: iid + "-opened",
      IDENTITY: iid + "-identity",
      LANGUAGE: iid + "-language",
      ISSHOWCHAT: iid + "-isshowchat",
      ISLANGUAGESWITCH: iid + "-islanguageswitch",
    };
    this.state = {
      lStore: lStore,
      opened:
        (this.props.buttonscript !== true ? this.props.defaultOpen : true) ||
        (this.props.mobile == "false" &&
         (this.props.iid === "90416134-b628-471c-805d-1daf895c565c" ?
           sessionStorage.getItem(lStore.OPENED) === "open" :
            localStorage.getItem(lStore.OPENED) === "open")),
      chatBindings: this.state.chatBindings,
      animation: {
        bubbleToFadeIn: true,
      },
      disabledChatbot: false,
      integrationData: null,
      botSettings: null,
      nudges: null,
      urlBasedNudges: null,
      isBotActive: false,
      bearerToken: "",
      resize: false,
      properties: [],
      nudgeValue: null,
      pagePropertyId: "",
      isOpenBot: false,
      botIntegrationData: null,
      urlLanguage: "",
      defaultLanguageURL: "",
      isWindowBotOpened: false,
      messengerTheme: "",
      isFullView: false,
    };
    window.addEventListener("message", this.windowMessage.bind(this), false);
  }
  windowMessage(event) {
    if (event.data === "chatbotwindowClose") {
      if (document.getElementById("chatbotiframe") !== null) {
        document.getElementById("chatbotiframe").style.display = "none";
      }
    }
    if (!this.state.opened && event.data === "msgwindowOpened") {
      if (
        this.state.messengerTheme === "StraightChatFull" ||
        this.state.messengerTheme === "ChatSuggestionsFull" ||
        this.state.messengerTheme === "WebWidgetMenusFull" ||
        this.state.messengerTheme === "StraightChatLarge"
      ) {
        window.parent.postMessage(
          "msgwindowTheme:" + this.state.messengerTheme,
          "*"
        );
        // if(this.state.messengerTheme === "WebWidgetMenusFull" ){
        //   this.resize_full();
        // }
      }
      this.setState({
        opened: true,
        isOpenBot:
          localStorage.getItem(this.state.lStore.ISSHOWCHAT) === "true"
            ? true
            : false,
      });
      
        if (this.props.iid === "90416134-b628-471c-805d-1daf895c565c") {
         sessionStorage.setItem(this.state.lStore.OPENED, "open");
      }
      else{
        localStorage.setItem(this.state.lStore.OPENED, "open");
      }
      this.recordClick();
      if (
        this.state.isOpenBot === true ||
        localStorage.getItem(this.state.lStore.ISSHOWCHAT) === "true"
      ) {
        if (document.getElementById("chatbotiframe") !== null) {
          setTimeout(() => {
            document.getElementById("chatbotiframe").style.display = "block";
            document
              .getElementById("chatbotiframe")
              .contentWindow.postMessage("chatwindowOpenedInMsg", "*");
          }, 1000);
        }
      }
    }

    if (event.data === "openChatWindow") {
      this.opened();
    }

    if (
      typeof event.data === "string" &&
      event.data.startsWith("msg-askmilli:")
    ) {
      let payload = event.data.substr(13);
      if (document.getElementById("chatbotiframe") !== null) {
        this.postMessage("remove-askmilli");
        document
          .getElementById("chatbotiframe")
          .contentWindow.postMessage("nudge_message:" + payload, "*");
      }
    }
    if (
      typeof event.data === "string" &&
      event.data.startsWith("message-nudge:")
    ) {
      let payload = JSON.parse(event.data.substr(14));
      if (payload.option === "OpenURL") {
        window.parent.postMessage("msgopenUrl:" + payload.value + "", "*");
      } else if (payload.option === "OpenMenuItem") {
        this.setState({ nudgeValue: payload });
        this.opened();
      } else if (payload.option === "SendToChatbot") {
        this.setState({ nudgeValue: payload });
        this.opened();
      }
    }
    if (
      typeof event.data === "string" &&
      event.data.startsWith("chatbotConId:")
    ) {
      var botConId = event.data.substring(13);
      if (botConId !== "") {
        this.checkConversation(botConId);
      }
    }
    // if (
    //   typeof event.data === "string" &&
    //   event.data.startsWith("update-styling:")
    // ) {
    //   let payload = event.data.substr(15);
    //   this.setState({ integrationSettings: JSON.parse(payload) });
    // }

    if (
      event !== undefined &&
      event.data !== undefined &&
      event.data === "messengerChatWindowOpened"
    ) {
      // if (this.state.messengerTheme === "WebWidgetMenusFull") {
      //   this.resize_full();
      // }
      this.setState({ isBotActive: true });
      localStorage.setItem(this.props.iid + "_is_bot_active", true);
      if (this.props.prechatData !== null) {
        document
          .getElementById("chatbotiframe")
          .contentWindow.postMessage(
            "prechat-input:" + JSON.stringify(this.props.prechatData),
            "*"
          );
      }
      if (
        this.state.messengerTheme === "StraightChatFull" &&
        document.getElementById("chatbotiframe") !== null
      ) {
        document
          .getElementById("chatbotiframe")
          .classList.add("bmb_bot_frame_starightfull");
        var micIconSetting = {
          isMicIcon: this.state.botSettings.isMicIcon,
          micIconColor: this.state.botSettings.colours.micColor,
          micIcon: this.state.botSettings.urls.micIcon,
          isBookNowButton: this.state.botSettings.isBookNowButton,
          bookNowButtonText: this.state.botSettings.bookNowButtonText,
          bookNowButtonUrl: this.state.botSettings.bookNowButtonUrl,
        };
        document
          .getElementById("chatbotiframe")
          .contentWindow.postMessage(
            "chatwindowSuggestOpenedInMsg:" + JSON.stringify(micIconSetting),
            "*"
          );
      }
    }

    if (
      event !== undefined &&
      event.data !== undefined &&
      typeof event.data === "string" &&
      event.data.startsWith("fetch_id_token")
    ) {
      // console.log("fetch_id_token received", event.data);
      if (event.data.substr(15) !== "") {
        this.setState({ bearerToken: event.data.substr(15) });
      }
    }

    if (
      event !== undefined &&
      event.data !== undefined &&
      event.data === "openMessengerBotClickAvtar"
    ) {
      // if (this.state.messengerTheme === "WebWidgetMenusFull") {
      //    this.resize_full();
      // }
      if (this.state.opened && this.state.messengerTheme !== "WebWidgetMenus") {
        if (document.getElementById("chatbotiframe") !== null) {
          document.getElementById("chatbotiframe").style.display = "block";
          if (this.props.prechatData !== null) {
            document
              .getElementById("chatbotiframe")
              .contentWindow.postMessage(
                "prechat-input:" + JSON.stringify(this.props.prechatData),
                "*"
              );
          }
          if (this.state.messengerTheme === "StraightChatFull") {
            document
              .getElementById("chatbotiframe")
              .classList.add("bmb_bot_frame_starightfull");
            var micIconSetting = {
              isMicIcon: this.state.botSettings.isMicIcon,
              micIconColor: this.state.botSettings.colours.micColor,
              micIcon: this.state.botSettings.urls.micIcon,
              isBookNowButton: this.state.botSettings.isBookNowButton,
              bookNowButtonText: this.state.botSettings.bookNowButtonText,
              bookNowButtonUrl: this.state.botSettings.bookNowButtonUrl,
            };
            document
              .getElementById("chatbotiframe")
              .contentWindow.postMessage(
                "chatwindowSuggestOpenedInMsg:" +
                  JSON.stringify(micIconSetting),
                "*"
              );
          } else {
            document
              .getElementById("chatbotiframe")
              .contentWindow.postMessage("chatwindowOpenedInMsg", "*");
          }
        }
      } else {
        var buttonColorsetting = {
          color: this.state.botSettings.colours.buttonColor,
          isFooterHide: this.state.botSettings.isFooterHide,
          calendarButtonColor:
            this.state.botSettings.calendarSetting.buttonColor,
          selectedButtonColor:
            this.state.botSettings.calendarSetting.selectedButtonColor,
          calendarTextColor:
            this.state.botSettings.calendarSetting.buttonTextColor,
          selectedTextColor:
            this.state.botSettings.calendarSetting.selectedButtonTextColor,
          calendarLayout: this.state.botSettings.calendarSetting.layout,
          widgetLayout: this.state.botSettings.widgetLayout,
        };
        var micIconSetting = {
          isMicIcon: this.state.botSettings.isMicIcon,
          micIconColor: this.state.botSettings.colours.micColor,
          micIcon: this.state.botSettings.urls.micIcon,
          isBookNowButton: this.state.botSettings.isBookNowButton,
          bookNowButtonText: this.state.botSettings.bookNowButtonText,
          bookNowButtonUrl: this.state.botSettings.bookNowButtonUrl,
        };
        const buttonColorInMsg = {
          buttonColorInMsg: buttonColorsetting,
          micIconSetting: micIconSetting,
        };
        document
          .getElementById("chatbotiframe")
          .contentWindow.postMessage(
            "buttonColorInMsg:" + JSON.stringify(buttonColorInMsg),
            "*"
          );
      }
    }
    if (
      event !== undefined &&
      event.data !== undefined &&
      event.data === "resizewindow"
    ) {
      this.setState({ resize: true });
      if (document.getElementById("chatbotiframe") !== null) {
        document
          .getElementById("chatbotiframe")
          .classList.add("bmb_bot_frame_resized");
      }
    }
  }
  /**
   * Posts a message to the parent window, if this window has one
   * @param {*} msg
   */
  postMessage(msg) {
    if (window.parent) {
      window.parent.postMessage(msg, "*");
    }
  }
  checkConversation(conversationId) {
    try {
      fetch(
        process.env.REACT_APP_API_URL +
          "/check-bot-start-conversation/" +
          conversationId +
          "?groupId=" +
          this.props.gid +
          "",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          if (json.result !== undefined && json.result !== null) {
            if (
              json.result.chatStarted === true &&
              json.result.propertyId !== null &&
              json.result.propertyId === this.props.propertyId
            ) {
              this.props.changeBotActivation("false");
              this.props.change_Chat_Started("true");
              this.setState({ botConId: conversationId });
            }
          }
        });
    } catch (e) {}
  }
  componentDidMount() {
    if (
      document.getElementById("chatbotiframe") !== undefined &&
      document.getElementById("chatbotiframe") !== null
    ) {
      let val = localStorage.getItem(this.props.iid + "_is_bot_active");
      if (val !== undefined && val !== null && val)
        this.setState({ isBotActive: true });
    }
    this.props.changeBotActivation("false");
    if (this.props.openChatWindow === true) {
      this.opened();
      this.postMessage("messengerwindowOpen");
    }
    //console.log("postMessage fetchToken");
    if (
      this.props.gid !== undefined &&
      this.props.gid === "d39a6ebb-1ca3-4f60-8e7f-ae9900185e7a"
    ) {
      this.postMessage("fetchToken");
    }

    this.startMessenger();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.opened !== this.state.opened) {
      //console.log("componentDidUpdate402", this.state.bearerToken);
      this.state.opened
        ? this.postMessage("messengerwindowOpen")
        : this.postMessage("messengerwindowClose");
    } else {
      if (prevState.opened === true && this.state.opened === true) {
        this.postMessage("messengerwindowOpen");

        if (document.getElementById("chatbotiframe") !== null) {
          //"componentDidUpdate", this.state.bearerToken);
          if (this.state.bearerToken !== "") {
            document
              .getElementById("chatbotiframe")
              .contentWindow.postMessage(
                "auth_token:" + this.state.bearerToken,
                "*"
              );
          }
        }
      }
    }
    if (this.state.resize === true) {
      if (document.getElementById("chatbotiframe") !== null) {
        document
          .getElementById("chatbotiframe")
          .classList.add("bmb_bot_frame_resized");
      }
    }
  }
  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  // trimUrl(url) {
  //   try {
  //     const parsed = new URL(url);
  //     const pathname = parsed.pathname.replace(/\/+$/, ''); // Remove trailing slash
  //     return `${parsed.origin}${pathname}`;
  //   } catch (e) {
  //     console.error("Invalid URL in trimUrl:", url);
  //     return url;
  //   }
  // }
  // getBaseDomain(url) {
  //   try {
  //     return new URL(url).hostname.toLowerCase();
  //   } catch (e) {
  //     console.error("Invalid URL in getBaseDomain:", url);
  //     return null;
  //   }
  // }

  // getLocaleFromUrl(url) {
  //   try {
  //     const params = new URL(url).searchParams;
  //     return params.get('locale');
  //   } catch (e) {
  //     return null;
  //   }
  // }

  async startMessenger() {
    var isAllowToOpen = false;
    var pageLinks =
      this.props.parent_location === undefined ||
      this.props.parent_location === null
        ? ""
        : this.props.parent_location;
    this.setState({ defaultLanguageURL: pageLinks });
    if (pageLinks.toLowerCase().includes("myma.ai")) {
      isAllowToOpen = true;
      if (this.props.buttonscript !== true) {
        if (this.props.botData !== undefined) {
          this.postMessage(
            "bmb_avtar_show:" + JSON.stringify(this.props.botData?.botSettings)
          );
        }
      }
    }
    const req = await fetch(
      process.env.REACT_APP_API_URL + "/check-messenger-restriction",
      {
        method: "POST",
        body: JSON.stringify({
          IntegrationId: this.props.iid,
          GroupId: this.props.gid,
          pageLinks: pageLinks,
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    var result = await req.json();
    if (result && result.data && result.data.response === "allow") {
      isAllowToOpen = true;
      if (result.data.propertyId !== null) {
        this.setState({ pagePropertyId: result.data.propertyId });
      }
      if (this.props.buttonscript !== true) {
        if (this.props.botData !== undefined) {
          this.postMessage(
            "bmb_avtar_show:" + JSON.stringify(this.props.botData?.botSettings)
          );
        }
      }
    } else this.postMessage("hide_messenger:");
    if (isAllowToOpen === true) {
      await this.registerPageLoad();
      setTimeout(() => {
        if (
          this.state.urlBasedNudges !== undefined &&
          this.state.urlBasedNudges !== null &&
          this.state.urlBasedNudges.length > 0
        ) {
          this.runurlBasedNudges();
        } else {
          this.runNudges();
        }
      }, 1000);
    }
  }
  async registerUser(gid, iid) {
    console.log(
      moment().format("YYYY-MM-DD hh:mm:ss"),
      "User is going to register"
    );
    let ip = "";
    try {
      ip = await publicIp.v4();
    } catch {
      var xhttp = new XMLHttpRequest();
      xhttp.open("GET", "https://api.ipify.org", true);
      xhttp.send();
      ip = xhttp.responseText;
    } finally {
      console.log("ipAddress", ip);
    }
    var user = {
      iid: iid,
      gid: gid,
      vid: undefined,
      sid: undefined,
      locale: "en-US",
      parent_location: this.props.parent_location,
      parent_referrer: this.props.parent_referrer,
      page_title: this.props.parent_title,
      ip: ip,
      botConversationId: "",
    };

    var identity = localStorage.getItem(this.state.lStore.IDENTITY);
    if (identity) {
      try {
        identity = JSON.parse(identity);
        user.vid = identity.vid;
        user.sid = identity.sid;
      } catch (e) {
        user.vid = undefined;
        user.sid = undefined;
      }
    }
    const req = await fetch(PAGE_VISIT_URL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: user,
      }),
    });
    var result = await req.json();
    if (result.disabled === false) {
      this.loadSettings(result, ip);
    }
  }

  async registerPageLoad() {
    if (
      this.props.gid !== undefined &&
      this.props.iid !== undefined &&
      this.props.botData === undefined
    ) {
      await this.registerUser(this.props.gid, this.props.iid);
    } else {
      if (this.props.botData !== undefined) {
        const result = this.props.botData;
        if (result.disabled === false) {
          var selectedLanguage = navigator.language || navigator.userLanguage;

          if (
            result.botSettings !== undefined &&
            result.botSettings !== null &&
            result.botSettings.features !== undefined &&
            result.botSettings.features !== null &&
            result.botSettings?.features?.defaultLanguageUrl === true &&
            result.botSettings.features.languageUrl !== undefined &&
            result.botSettings.features.languageUrl !== null &&
            result.botSettings.features.languageUrl.length > 0
          ) {
            const botFeatures = result?.botSettings?.features;
            console.log("622",this.state.defaultLanguageURL)
            const currentUrl = new URL(this.state.defaultLanguageURL);
            
            const currentUrlStr = currentUrl.href.toLowerCase();

            let matchedLangCode = null;
            botFeatures.languageUrl.forEach((lang) => {
              const langUrlStr = lang.url.toLowerCase();

              if (currentUrlStr.includes(langUrlStr)) {
                matchedLangCode = lang.languageCode;
              }
            });

            selectedLanguage =
              matchedLangCode === null || matchedLangCode === undefined
                ? result.botSettings.defaultLanguage
                : matchedLangCode;
          }
          console.log("langsel", selectedLanguage);
          if (result.nudges) {
            var nudges = [];

            result.nudges.map((k) => {
              if (selectedLanguage !== "en" && selectedLanguage !== "en-US") {
                if (
                  k.otherLanguages !== undefined &&
                  k.otherLanguages !== null &&
                  k.otherLanguages.length > 0
                ) {
                  const languageSelect =
                    selectedLanguage === "zh-TW" ? "hk" : selectedLanguage;
                  if (
                    k.otherLanguages.filter(
                      (m) => m.languageCode === languageSelect
                    ).length > 0
                  ) {
                    k.otherLanguages
                      .filter((m) => m.languageCode === languageSelect)
                      .map((x) => {
                        nudges.push({
                          ...k,
                          buttons: x.buttons,
                          eyeCatcher: x.eyeCatcher,
                        });
                      });
                  } else {
                    nudges.push(k);
                  }
                } else {
                  nudges.push(k);
                }
              } else {
                nudges.push(k);
              }
            });

            this.setState({ nudges: nudges });
          }

          if (result.urlBasedNudges) {
            var urlBasedNudges = [];

            result.urlBasedNudges.map((k) => {
              if (selectedLanguage !== "en" && selectedLanguage !== "en-US") {
                if (
                  k.otherLanguages !== undefined &&
                  k.otherLanguages !== null &&
                  k.otherLanguages.length > 0
                ) {
                  if (
                    k.otherLanguages.filter(
                      (m) => m.languageCode === selectedLanguage
                    ).length > 0
                  ) {
                    k.otherLanguages
                      .filter((m) => m.languageCode === selectedLanguage)
                      .map((x) => {
                        urlBasedNudges.push({
                          ...k,
                          buttons: x.buttons,
                          eyeCatcher: x.eyeCatcher,
                        });
                      });
                  } else {
                    urlBasedNudges.push(k);
                  }
                } else {
                  urlBasedNudges.push(k);
                }
              } else {
                urlBasedNudges.push(k);
              }
            });

            this.setState({ urlBasedNudges: urlBasedNudges });
          }

          if (result.botSettings) {
            var botId = result?.botSettings?.chatBot?.botIntegrationId;
            // var theme = result.botSettings.theme;
            // var isFullView = false;
            // let isShowChatBOT = false;
            // if (theme === "StraightChat") {
            //   isShowChatBOT = true;
            // }
            // else if (theme === "StraightChatFull") {
            //   isShowChatBOT = true;
            //   isFullView = true;
            // }
            // else if (theme === "ChatSuggestionsFull") {
            //   isFullView = true;
            // }
            // if (isShowChatBOT === true) {
            //   this.props.changeMode(false);
            //   localStorage.setItem(this.state.lStore.ISSHOWCHAT, "true");
            // }
            this.setState({
              // messengerTheme: theme,
              // isFullView: isFullView,
              botSettings: result.botSettings,
              //isOpenBot: isShowChatBOT,
              // botIntegrationData: {
              //   disabled: result.botSettings.chatBot.botDisabled,
              //   iid: botId
              // }
            });
            this.registerUser(this.props.gid, this.props.iid);
          }
        }
      }
    }
  }

  // trimUrl(url) {
  //   const fixedPath = url.endsWith('/')
  //     ? this.trimUrl(url.substring(0, url.length - 1))
  //     : url;

  //   return fixedPath;
  // }

  async LoadData() {
    await fetch(
      BMB_INTEGRATION + "/" + `${this.props.iid}?group_id=${this.props.gid}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then(async (resultIntegration) => {
        let guestLifecycle = [];
        var displayService = 0;
        var integrationType = resultIntegration.channel;

        this.setState({ integration: resultIntegration });

        if (resultIntegration.botSettings !== null) {
          if (
            resultIntegration.botSettings.urlRestrictions !== null &&
            resultIntegration.botSettings.urlRestrictions.disabled === false
          ) {
            this.postMessage(
              "ismsgurl:" +
                resultIntegration.botSettings.urlRestrictions.disabled
            );
          } else {
            this.postMessage("ismsgurlremove");
          }

          this.setState({ pageSetting: resultIntegration.botSettings });
          const botsetting = resultIntegration.botSettings;

          const reqWebIntegration = await fetch(
            BMB_Group_INTEGRATION +
              `?channel=WebsiteDirectLine&groupID=${this.props.gid}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );

          // var resultWebIntegration = await reqWebIntegration.json();
          let resultWebIntegration;
          try {
            resultWebIntegration = await reqWebIntegration.json();
          } catch (e) {
            console.warn(
              "Failed to parse JSON response, response might be empty or invalid",
              e
            );
            resultWebIntegration = { data: [] };
          }
          // console.log(1239, resultWebIntegration)
          var webIntegrationList = resultWebIntegration.data;
          this.setState({ allIntegrationList: webIntegrationList });
          if (
            this.props.integration_channel !== "HelpCenter" &&
            this.props.level === "Property"
          ) {
            var engepropertyIntegrations =
              botsetting.engegedProperties.engagedPropertyUrls;
            var webinte = engepropertyIntegrations.filter(
              (k) =>
                k.id.includes(this.props.propertyId) && k.integrationId !== null
            );
            if (webinte.length > 0) {
              var inte = webIntegrationList.filter(
                (k) => k.id === webinte[0].integrationId
              );
              this.setState({
                chatBotDetails: {
                  disabled: botsetting.chatBot.propertyChatBot.disabled,
                  iid: inte[0].id,
                  icon:
                    inte[0].botSettings.urls.icon === null &&
                    inte[0].botSettings.urls.icon === ""
                      ? "/res/bot-off.png"
                      : inte[0].botSettings.urls.icon,
                  name: inte[0].botSettings.name,
                },
              });
            } else {
              var webIntegration = webIntegrationList.filter((i) =>
                i.properties.includes(this.props.propertyId)
              );
              if (webIntegration?.length > 0) {
                this.setState({
                  chatBotDetails: {
                    disabled: botsetting.chatBot.propertyChatBot.disabled,
                    iid: webIntegration[0].id,
                    icon: webIntegration[0].botSettings.urls.icon,
                    name: webIntegration[0].botSettings.name,
                  },
                });
              }
            }
          } else {
            if (
              botsetting.chatBot !== null &&
              botsetting.chatBot.botIntegrationId !== null &&
              botsetting.chatBot.botIntegrationId !== ""
            ) {
              var webint = webIntegrationList.filter(
                (l) => l.id === botsetting.chatBot.botIntegrationId
              );
              if (webint.length > 0) {
                this.setState({
                  chatBotDetails: {
                    disabled: false,
                    iid: botsetting.chatBot.botIntegrationId,
                    icon: webint[0].botSettings.urls.icon,
                    name: webint[0].botSettings.name,
                  },
                });
              }
            }
          }
          // const filtered = Language.filter((el) => {
          //   return botsetting.languages.indexOf(el.id) !== -1;
          // });
          // const selectedLang = this.state.languageOptions.filter(
          //   (el) => el.id === this.state.language
          // );
          // if (selectedLang.length > 0) {
          //   this.setState({
          //     languageOptions: filtered,
          //     languageCode: selectedLang[0].code,
          //     langLocale: selectedLang[0].locale,
          //   });
          // } else {
          //   this.setState({ languageOptions: filtered });
          // }

          var divNode = document.createElement("div");
          var html = "";
          var head = document.getElementsByTagName("head");
          if (
            resultIntegration.botSettings.customFonts !== undefined &&
            resultIntegration.botSettings.customFonts.length > 0
          ) {
            resultIntegration.botSettings.customFonts.map(
              (m) =>
                (html =
                  html +
                  `
                   @font-face {
                   font-family: '${m.fontName} !important';           
                   src: url(${m.fontLink}) format('woff2') ;                    
                 }`)
            );
          }
          if (resultIntegration.botSettings.fonts !== undefined) {
            if (resultIntegration.botSettings.fonts.website !== undefined) {
              html =
                html +
                `
              body {
               font-family: ${resultIntegration.botSettings.fonts.website} !important
               }`;
            }
          }
          if (resultIntegration.botSettings.colours !== undefined) {
            if (
              resultIntegration.botSettings.colours.buttonColor !== undefined
            ) {
              html =
                html +
                `
              #footer-bar .active-nav i{
                background-image:linear-gradient(to bottom, #5D9CEC, ${resultIntegration.botSettings.colours.buttonColor}) !important;
                  color:${resultIntegration.botSettings.colours.buttonTextColor} !important;
                }
                .btn-submit-color {
                    background-image: linear-gradient(to bottom, ${resultIntegration.botSettings.colours.buttonColor}, ${resultIntegration.botSettings.colours.buttonColor});
                    color:${resultIntegration.botSettings.colours.buttonTextColor} !important;
                  }
                  .list-group svg{
                    fill:${resultIntegration.botSettings.colours.buttonColor} !important
                  }
                  .list-group svg:hover{
                    fill:#5D9CEC !important
                  }`;
            }
          }
          if (this.props.mobile !== "true") {
            if (
              resultIntegration.botSettings.customCss !== null &&
              resultIntegration.botSettings.customCss !== undefined &&
              resultIntegration.botSettings.customCss.isDisabled === false
            ) {
              if (
                resultIntegration.botSettings.customCss.text !== null &&
                resultIntegration.botSettings.customCss.text !== ""
              ) {
                html = html + resultIntegration.botSettings.customCss.text;
              }
            }
          }
          // widgetLayout css condition to set borderRadius
          if (
            resultIntegration.botSettings.widgetLayout !== undefined &&
            resultIntegration.botSettings.widgetLayout !== null
          ) {
            if (resultIntegration.botSettings.widgetLayout === "Square Edges") {
              var borderRadius = "0px";
              html =
                html +
                `
                  .card-mobile,.rounded-s,.rounded-xs,.rounded-m,.rounded-sm,
                  .welcome-btn,.header-bar-detached,.btn-option-color,.btn-mobile,.btn-formview,
                  .theme-light .form-custom input, 
                  .theme-light .form-custom textarea, 
                  .theme-light .form-custom select,
                  .react-select__control  {
                      border-radius: ${borderRadius} !important
                  }`;
            } else {
              html =
                html +
                `.react-select__control  {
                      border-radius: 10px !important
                  }`;
            }
          }
          html = `<style>${html}</style>`;
          head[0].innerHTML = head[0].innerHTML + html;
          document.body.appendChild(divNode);
          if (resultIntegration.botSettings.guestLifeCycle !== null) {
            guestLifecycle = resultIntegration.botSettings.guestLifeCycle;
          }
          displayService = resultIntegration.botSettings.displayServices;
        }

        fetch(PROPERTIES_URL + "/" + this.props.gid, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((res) => res.json())
          .then(async (result) => {
            if (
              this.props.propertyId !== undefined &&
              this.props.propertyId !== null &&
              this.props.propertyId !== ""
            ) {
              var properties = result.properties.filter(
                (i) => i.id === this.props.propertyId
              );
              if (properties.length > 0) {
                this.setState({
                  propertyName: properties[0].name,
                  propertyId: this.props.propertyId,
                  propertyLogo: properties[0].images,
                });
              }
            }
            // await fetch(
            //   MESSENGER_CATEGORIES_URL + `?groupId=${this.props.gid}&propertyId=${this.props.propertyId}`,
            //   {
            //     method: "GET",
            //     headers: {
            //       Accept: "application/json",
            //       "Content-Type": "application/json",
            //     },
            //   }).then(res => res.json()).then(res => {
            //     var categorylist = res.result;
            //     categorylist = categorylist.sort((a, b) => a.displayOrder - b.displayOrder)
            //     this.setState({ categoryList: categorylist });
            //   });
            // await Axios({
            //   method: "post",
            //   url: `${MESSENGER_URL}?groupId=${this.props.gid}&propertyId=${this.props.propertyId}&languageCode=${this.state.language === "zh-TW" ? "hk" : this.state.language}`,
            //   data: {
            //     "authentication": {
            //       "token": this.state.bearerToken
            //     }
            //   }
            // }).then((res) => {
            //   let messengerData = res.data.result.filter((i) => i.status === "Active");
            //   if (guestLifecycle.length > 0) {
            //     messengerData = messengerData.filter((i) => i.guestLifeCycle !== null && i.guestLifeCycle.length > 0 && i.guestLifeCycle.find(x => guestLifecycle.includes(x)));
            //   }
            //   messengerData = messengerData.sort((a, b) => a.displayOrder - b.displayOrder);
            //   var img = []
            //   if (messengerData.length > 0) {
            //     messengerData.map(i => {
            //       if (i.imageLink !== "") {
            //         img.push({ src: i.imageLink, desc: "", sub: i.title })
            //       }
            //     });
            //   }
            //   this.setState({
            //     mediaList: img,
            //     messengerData: messengerData
            //   });

            //   setTimeout(() => {
            //     this.setState({ loader: false });
            //   }, 500);
            // });
          });
      });
  }

  async loadSettings(result, ip) {
    if (result && result.vid && result.sid) {
      if (this.props.previewMode == "false") {
        this.setState({ disabledChatbot: result.disabled });
      }
      //   if (user.sid !== result.sid) {
      //     localStorage.removeItem(this.state.lStore.BOTCLICK);
      //   }
      //Restrict Bot based upon the IP Address
      if (result.whiteListedIpAddresses.length > 0) {
        if (result.whiteListedIpAddresses.find((x) => x === ip) === undefined) {
          this.setState({ blockChatbot: true });
        }
      }
      localStorage.setItem(this.state.lStore.IDENTITY, JSON.stringify(result));
      var localStorageLanguage = localStorage.getItem(
        this.state.lStore.LANGUAGE
      );
      var localStorageIsLanguageSwitch = localStorage.getItem(
        this.state.lStore.ISLANGUAGESWITCH
      );
      var urlLang = "";
      var isdefaultLangUrl = false;
      const botFeatures = result.botSettings.features;
      console.log(localStorageLanguage);
      if (
        botFeatures !== undefined &&
        botFeatures !== null &&
        botFeatures.defaultLanguageUrl === true
      ) {
        isdefaultLangUrl = true;
        if (
          botFeatures.languageUrl !== null &&
          botFeatures.languageUrl !== undefined &&
          botFeatures.languageUrl.length > 0
        ) {
          if (
            localStorageLanguage !== "undefined" &&
            localStorageLanguage !== undefined &&
            localStorageLanguage !== null &&
            localStorageLanguage !== "" &&
            localStorageIsLanguageSwitch == "true"
          ) {
            console.log("1104");
            urlLang = localStorageLanguage;
          } else {
            const currentUrl = new URL(this.state.defaultLanguageURL);
            const currentUrlStr = currentUrl.href.toLowerCase();

            let matchedLangCode = null;
            botFeatures.languageUrl.forEach((lang) => {
              const langUrlStr = lang.url.toLowerCase();

              if (currentUrlStr.includes(langUrlStr)) {
                matchedLangCode = lang.languageCode;
              }
            });

            urlLang =
              matchedLangCode === null || matchedLangCode === undefined
                ? result.botSettings.defaultLanguage
                : matchedLangCode;
          }
        }
      }
      console.log("urllang", urlLang, result);
      if (
        isdefaultLangUrl === true &&
        localStorageIsLanguageSwitch !== "true"
      ) {
        this.setState({
          vid: result.vid,
          sid: result.sid,
          lang:
            urlLang === "" || urlLang === null
              ? result.botSettings.defaultLanguage
              : urlLang,
        });
      } else {
        var lang = "";
        var userLang = navigator.language || navigator.userLanguage;
        console.log(
          "navigatorLang",
          navigator.language,
          navigator.userLanguage
        );
        if (
          userLang != undefined &&
          userLang != "" &&
          result.botSettings.languages.length > 0
        ) {
          if (userLang.indexOf("-") > 0 && userLang.includes("en")) {
            //ENGLISH
            // lang = "en";
          } else if (userLang === "zh-CN") {
            //SC
            if (
              result.botSettings.languages.filter((m) => m === "zh").length > 0
            ) {
              lang = "zh";
            }
          } else if (userLang === "zh-TW") {
            //TC
            if (
              result.botSettings.languages.filter((m) => m === "zh-TW").length >
              0
            ) {
              lang = "zh-TW";
            }
          } else {
            if (
              result.botSettings.languages.filter((m) => m === userLang)
                .length > 0
            ) {
              lang = userLang;
            }
          }
        }

        try {
          if (localStorageLanguage) {
            this.setState({
              vid: result.vid,
              sid: result.sid,
              lang: localStorageLanguage,
            });
          } else {
            this.setState({
              vid: result.vid,
              sid: result.sid,
              lang: lang === "" ? result.botSettings.defaultLanguage : lang,
            });
          }
        } catch (e) {
          this.setState({
            vid: result.vid,
            sid: result.sid,
            lang: lang === "" ? result.botSettings.defaultLanguage : lang,
          });
        }
      }
      console.log("lang1", this.state.lang);
      this.props.setIsGroupButton("false");
      this.props.change_Integration_Channel(result.channel);
      if (result.channel === "HelpCenter") {
        this.props.changeLevel("Property");
        if (
          (this.props.pid === "" || this.props.pid === undefined) &&
          result.level === "Group" &&
          result.properties.length > 1
        ) {
          const reqProperties = await fetch(
            PROPERTIES_URL + "/" + this.props.gid,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
          var resultProperties = await reqProperties.json();
          const finalResult = [];
          result.properties.forEach((p) => {
            resultProperties.properties.forEach((r) => {
              if (p === r.id) {
                finalResult.push({
                  value: r.id,
                  label: r.name,
                  displayOrder: r.displayOrder,
                  domain:
                    r.domains != undefined &&
                    r.domains.length > 0 &&
                    r.domains.filter((m) => m.priority === 1).length > 0
                      ? r.domains.filter((m) => m.priority === 1)[0].type
                      : "",
                  currency: r.currency,
                });
              }
            });
          });
          const sortfinalResult = finalResult.sort(
            this.dynamicSort("displayOrder")
          );
          if (sortfinalResult.length > 0) {
            var property = this.props.propertyId;
            if (property) {
              let obj = sortfinalResult.find((o) => o.value === property);
              this.props.changePropertyId(
                obj === undefined ? sortfinalResult[0].value : obj.value
              );
            } else {
              this.props.changePropertyId(sortfinalResult[0].value);
              const groupCall = await fetch(GROUP_URL + "/" + this.props.gid, {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              });
              var groupData = await groupCall.json();
              if (groupData.group.domain === "") {
                this.setState({
                  pid: sortfinalResult[0].value,
                });
                this.props.changePropertyId(sortfinalResult[0].value);
                this.props.changeDomain(sortfinalResult[0].domain);
                this.props.changeCurrency({
                  propertyCurrency: sortfinalResult[0].currency,
                  groupCurrency: "",
                });
              }
            }
            try {
              var propertyName = this.props.propertName;
              if (propertyName) {
                let obj = sortfinalResult.find((o) => o.label === propertyName);
                this.props.changePropertyName(obj.label);
              } else {
                const groupCall = await fetch(
                  GROUP_URL + "/" + this.props.gid,
                  {
                    method: "GET",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  }
                );

                var groupData = await groupCall.json();
                //If not group level domain setup
                if (groupData.group.domain === "") {
                  this.props.changePropertyName(sortfinalResult[0].label);
                }
              }
            } catch (e) {
              const groupCall = await fetch(GROUP_URL + "/" + this.props.gid, {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              });

              var groupData = await groupCall.json();
              if (groupData.group.domain === "") {
                this.props.changePropertyName(sortfinalResult[0].label);
              }
            }
          }
          this.setState({ properties: sortfinalResult });
        } else if (
          (this.props.pid === "" || this.props.pid === undefined) &&
          result.properties.length === 1
        ) {
          const reqProperties = await fetch(
            PROPERTIES_URL + "/" + this.props.gid,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
          var resultProperties = await reqProperties.json();
          result.properties.forEach((p) => {
            resultProperties.properties.forEach((r) => {
              if (p === r.id) {
                this.props.changePropertyId(r.id);
                this.props.changePropertyName(r.name);
                this.props.changeDomain(
                  r.domains != undefined &&
                    r.domains.length > 0 &&
                    r.domains.filter((m) => m.priority === 1).length > 0
                    ? r.domains.filter((m) => m.priority === 1)[0].type
                    : ""
                );
                this.props.changeCurrency({
                  propertyCurrency: r.currency,
                  groupCurrency: "",
                });
                this.setState({ pid: r.id });
              }
            });
          });
        } else if (this.props.pid !== "" && this.props.pid !== undefined) {
          const reqProperties = await fetch(
            PROPERTIES_URL + "/" + this.props.gid,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );

          var resultProperties = await reqProperties.json();
          resultProperties.properties.forEach((r) => {
            if (this.props.pid === r.id) {
              this.props.changePropertyName(r.name);
              this.props.changePropertyId(r.id);
              this.props.changeDomain(
                r.domains != undefined &&
                  r.domains.length > 0 &&
                  r.domains.filter((m) => m.priority === 1).length > 0
                  ? r.domains.filter((m) => m.priority === 1)[0].type
                  : ""
              );
              this.props.changeCurrency({
                propertyCurrency: r.currency,
                groupCurrency: "",
              });
              this.setState({ pid: r.id });
            }
          });
        }
      } else {
        const reqProperties = await fetch(
          PROPERTIES_URL + "/" + this.props.gid,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        var resultProperties = await reqProperties.json();
        const finalResult = [];
        result.properties.forEach((p) => {
          resultProperties.properties.forEach((r) => {
            if (p === r.id) {
              finalResult.push({
                value: r.id,
                label: r.name,
                displayOrder: r.displayOrder,
                domain:
                  r.domains != undefined &&
                  r.domains.length > 0 &&
                  r.domains.filter((m) => m.priority === 1).length > 0
                    ? r.domains.filter((m) => m.priority === 1)[0].type
                    : "",
                currency: r.currency,
              });
            }
          });
        });
        const sortfinalResult = finalResult.sort(
          this.dynamicSort("displayOrder")
        );
        this.setState({
          pid: "-1",
          properties: sortfinalResult,
        });
        const groupCall = await fetch(GROUP_URL + "/" + this.props.gid, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        var groupData = await groupCall.json();
        this.props.changeGroupId(this.props.gid);
        this.props.changeGroupName(groupData.group.name);
        if (this.state.pagePropertyId !== "") {
          this.props.changeLevel("Property");
          this.props.changePropertyId(this.state.pagePropertyId);
          this.props.changeDomain("");
          var property = sortfinalResult.filter(
            (i) => i.value === this.state.pagePropertyId
          );
          this.props.changePropertyName(property[0].label);
          this.props.changeCurrency({
            propertyCurrency: property[0].currency,
            groupCurrency: "",
          });
        } else {
          this.props.changeLevel("Group");
          this.props.changePropertyId("-1");
          this.props.changeDomain("");
          this.props.changePropertyName("");
          this.props.changeCurrency({
            propertyCurrency: "",
            groupCurrency: groupData.group.currency,
          });
        }
      }
    }
    if (result.nudges) {
      var selectedLanguage = navigator.language || navigator.userLanguage;
      if (
        result.botSettings !== undefined &&
        result.botSettings !== null &&
        result.botSettings.features !== undefined &&
        result.botSettings.features !== null &&
        result.botSettings.features.defaultLanguageUrl === true &&
        result.botSettings.features.languageUrl !== undefined &&
        result.botSettings.features.languageUrl !== null &&
        result.botSettings.features.languageUrl.length > 0
      ) {
        const botFeatures = result?.botSettings?.features;
        const currentUrl = new URL(this.state.defaultLanguageURL);
        const currentUrlStr = currentUrl.href.toLowerCase();

        let matchedLangCode = null;
        botFeatures.languageUrl.forEach((lang) => {
          const langUrlStr = lang.url.toLowerCase();

          if (currentUrlStr.includes(langUrlStr)) {
            matchedLangCode = lang.languageCode;
          }
        });

        selectedLanguage =
          matchedLangCode === null || matchedLangCode === undefined
            ? result.botSettings.defaultLanguage
            : matchedLangCode;
      }
      console.log("selct", selectedLanguage);
      if (result.nudges) {
        var nudges = [];

        result.nudges.map((k) => {
          if (selectedLanguage !== "en" && selectedLanguage !== "en-US") {
            if (
              k.otherLanguages !== undefined &&
              k.otherLanguages !== null &&
              k.otherLanguages.length > 0
            ) {
              const languageSelect =
                selectedLanguage === "zh-TW" ? "hk" : selectedLanguage;
              if (
                k.otherLanguages.filter(
                  (m) => m.languageCode === languageSelect
                ).length > 0
              ) {
                k.otherLanguages
                  .filter((m) => m.languageCode === languageSelect)
                  .map((x) => {
                    nudges.push({
                      ...k,
                      buttons: x.buttons,
                      eyeCatcher: x.eyeCatcher,
                    });
                  });
              } else {
                nudges.push(k);
              }
            } else {
              nudges.push(k);
            }
          } else {
            nudges.push(k);
          }
        });

        this.setState({ nudges: nudges });
      }
    }

    if (result.botSettings) {
      var botId = result.botSettings.chatBot.botIntegrationId;
      var theme = result.botSettings.theme;
      console.log('proptheme', theme)
      var isFullView = false;
      let isShowChatBOT = false;
      var isresize = false;
      if (theme === "StraightChat") {
        isShowChatBOT = true;
      } else if (theme === "StraightChatFull") {
        isShowChatBOT = true;
        isFullView = true;
        if (this.state.opened) {
          window.parent.postMessage("msgwindowTheme:" + theme, "*");
        }
      } else if (theme === "StraightChatLarge") {
        isresize = true;
        isShowChatBOT = true;
        if (this.state.opened) {
          window.parent.postMessage("msgwindowTheme:" + theme, "*");
        }
      } else if (theme === "WebWidgetMenusFull") {
        isresize = true;
        if (this.state.opened) {
          window.parent.postMessage("msgwindowTheme:" + theme, "*");
        }
      } else if (theme === "ChatSuggestionsFull") {
        isFullView = true;
        localStorage.removeItem(this.state.lStore.ISSHOWCHAT);
        if (this.state.opened) {
          window.parent.postMessage("msgwindowTheme:" + theme, "*");
        }
      }
      if (isShowChatBOT === true) {
        this.props.changeMode(false);
        localStorage.setItem(this.state.lStore.ISSHOWCHAT, "true");
        if (this.state.pagePropertyId !== "") {
          await fetch(
            BMB_INTEGRATION +
              "/" +
              `${this.props.iid}?group_id=${this.props.gid}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          )
            .then((res) => res.json())
            .then(async (resultIntegration) => {
              if (resultIntegration.botSettings.engegedProperties !== null) {
                var engepropertyIntegrations =
                  resultIntegration.botSettings.engegedProperties
                    .engagedPropertyUrls;
                var webinte = engepropertyIntegrations.filter(
                  (k) =>
                    k.id.includes(this.state.pagePropertyId) &&
                    k.integrationId !== null
                );
                if (webinte.length > 0) {
                  botId = webinte[0].integrationId;
                }
              }
            });
        }
      } else {
        localStorage.removeItem(this.state.lStore.ISSHOWCHAT);
        this.props.changeMode(true);
      }
      this.setState({
        messengerTheme: theme,
        isFullView: isFullView,
        botSettings: result.botSettings,
        isOpenBot: isShowChatBOT,
        resize: isresize,
        botIntegrationData: {
          disabled: result.botSettings.chatBot.botDisabled,
          iid: botId,
        },
      });
    }
    await this.LoadData();
  }
  runurlBasedNudges() {
    if (
      !this.state.urlBasedNudges ||
      this.state.opened ||
      this.state.disabledChatbot
    ) {
      return;
    }

    if (this.state.urlBasedNudges.length > 0) {
      const checkUrl = (url) => {
        return url
          .replace(/^.*?:\/\//, "")
          .replace(/^file:\/\//, "")
          .replace(/\/$/, "")
          .replace(/#.*$/, "")
          .trim();
      };
      const pageLinks =
        this.props.parent_location === undefined ||
        this.props.parent_location === null
          ? ""
          : this.props.parent_location;

      const basePageLink = checkUrl(pageLinks.split("?")[0]);

      const matchingNudges = this.state.urlBasedNudges.filter((nudge) => {
        if (nudge.pageURL) {
          const nudgeUrls = nudge.pageURL
            .split(",")
            .map((url) => checkUrl(url.trim()));

          return nudgeUrls.some((nudgeUrl) => basePageLink === nudgeUrl);
        }
        return false;
      });

      if (matchingNudges.length > 0) {
        let lastDelay = 0;

        matchingNudges.forEach((matchingNudge) => {
          const delay =
            this.props.mobile === "true"
              ? matchingNudge.delayInMillisecondsInMobile
              : matchingNudge.delayInMilliseconds;

          setTimeout(() => {
            if (
              (this.props.mobile === "true" &&
                !matchingNudge.disabledInMobile) ||
              (this.props.mobile !== "true" && !matchingNudge.disabledInDesktop)
            ) {
              if (
                matchingNudge.eyeCatcher &&
                matchingNudge.eyeCatcher.response &&
                matchingNudge.eyeCatcher.response.messages
              ) {
                if (
                  matchingNudge.buttons &&
                  matchingNudge.buttons.length > 0
                  //  && this.props.mobile === "false"
                ) {
                  this.postMessage(
                    "msgXnudgebutton:" +
                      JSON.stringify({
                        text: matchingNudge.eyeCatcher.response.messages,
                        buttons: matchingNudge.buttons,
                        botSettings: this.state.botSettings,
                      })
                  );
                } else {
                  this.postMessage(
                    "msgXeyecatcher:" +
                      JSON.stringify(matchingNudge.eyeCatcher.response.messages)
                  );
                }
              }
            }
          }, lastDelay + delay);

          lastDelay += delay;
        });
      } else {
        this.runNudges();
      }
    }
  }
  runNudges() {
    if (!this.state.nudges || this.state.opened || this.state.disabledChatbot) {
      return;
    }

    if (typeof Storage !== "undefined") {
      this.postMessage("msgX_totalnudges:" + this.state.nudges.length);
    }
    this.state.nudges.forEach((nudge) => {
      if (
        this.props.mobile === "true"
          ? !nudge.disabledInMobile
          : !nudge.disabledInDesktop
      ) {
        setTimeout(
          () => {
            if (
              nudge.eyeCatcher &&
              nudge.eyeCatcher.response &&
              nudge.eyeCatcher.response.messages
            ) {
              if (
                nudge.buttons !== null &&
                nudge.buttons !== undefined &&
                // this.props.mobile == "false" &&
                nudge.buttons.length > 0
              ) {
                this.postMessage(
                  "msgXnudgebutton:" +
                    JSON.stringify({
                      text: nudge.eyeCatcher.response.messages,
                      buttons: nudge.buttons,
                      botSettings: this.state.botSettings,
                    })
                );
              } else {
                this.postMessage(
                  "msgXeyecatcher:" +
                    JSON.stringify(nudge.eyeCatcher.response.messages)
                );
              }
            }
          },
          this.props.mobile === "true"
            ? nudge.delayInMillisecondsInMobile
            : nudge.delayInMilliseconds
        );
      }
    });
  }
  opened() {
    this.setState({
      opened: true,
      isOpenBot:
        localStorage.getItem(this.state.lStore.ISSHOWCHAT) === "true"
          ? true
          : false,
    });
    this.postMessage("messengerwindowOpen");
    
      if (this.props.iid === "90416134-b628-471c-805d-1daf895c565c") {
         sessionStorage.setItem(this.state.lStore.OPENED, "open");
      }
      else{
        localStorage.setItem(this.state.lStore.OPENED, "open");
      }
    this.recordClick();
    if (
      this.state.isOpenBot === true ||
      localStorage.getItem(this.state.lStore.ISSHOWCHAT) === "true"
    ) {
      if (document.getElementById("chatbotiframe") !== null) {
        setTimeout(() => {
          document.getElementById("chatbotiframe").style.display = "block";
          document
            .getElementById("chatbotiframe")
            .contentWindow.postMessage("chatwindowOpenedInMsg", "*");
        }, 1000);
      }
    }
  }
  closed() {
    // if (this.state.resize === true) {
    //   this.setState({ resize: false });
    //   this.postMessage("resizeactual");
    // }
    this.postMessage("messengerwindowClose");
    window.postMessage("openAvtar");
    // if (!this.props.defaultOpen) {
    this.setState({
      opened: false,
      isOpenBot: false,
    });
    localStorage.removeItem(this.state.lStore.OPENED);
    sessionStorage.removeItem(this.state.lStore.OPENED);
    // }
    // this.setState({ botclick: false });
    // setTimeout(() => {
    //   this.runNudges();
    // }, 1000);
  }
  chatBotDetails(details) {
    this.setState({ chatBotDetails: details });
  }
  resize_full() {
    this.setState({ resize: true });
    this.postMessage("resizefull");
    if (document.getElementById("chatbotiframe") !== null) {
      if (this.props.isMessengerMode === false) {
        setTimeout(() => {
          document.getElementById("chatbotiframe").style.display = "block";
        }, 100);
      }
      document
        .getElementById("chatbotiframe")
        .classList.add("bmb_bot_frame_resized");
    }
  }
  resize_actual() {
    this.setState({ resize: false });
    this.postMessage("resizeactual");
  }
  hintClosed() {
    this.setState({ currentNudge: undefined });
  }
  recordClick() {
    if (
      this.props.gid !== undefined &&
      this.props.iid !== undefined &&
      this.state.sid !== undefined &&
      this.props.avatarClick === "false"
    ) {
      const pid = this.props.propertyId;
      var body = {
        groupId: this.props.gid,
        integrationId: this.props.iid,
        type: 1, // stats type
      };
      if (
        this.props.propertyId !== "" &&
        this.props.propertyId !== "-1" &&
        this.props.propertyId !== undefined
      ) {
        body = { ...body, propertyId: pid };
      }
      const req = fetch(`${api_ADD_MESSENGER_CLICK}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      const reqsession = fetch(`${MESSENGER_CLICKS}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          groupId: this.props.gid,
          sessionId: this.state.sid,
          integrationId: this.props.iid,
        }),
      });
      this.props.changeAvatarClick(true);
    }
  }
  openWindowBot() {
    this.setState({ isWindowBotOpened: true });
  }

  closeWindowBot() {
    this.setState({ isWindowBotOpened: false });
  }

  render() {
    const {
      animation,
      botSettings,
      pid,
      integrationData,
      nudges,
      opened,
      disabledChatbot,
      isFullView,
      messengerTheme,
      isOpenBot,
    } = this.state;
    const { iid, gid, mobile } = this.props;
    var fullview = isFullView === true ? "true" : this.props.mobile;

    return (
      <Fragment>
        {botSettings !== null && (
          <Fragment>
            {this.state.isOpenBot &&
              this.props.botActivation === "false" &&
              !this.state.isWindowBotOpened &&
              this.state.botIntegrationData !== null && (
                <ChatBot
                  botIntegrationData={this.state.botIntegrationData}
                  gid={gid}
                  isValid={this.props.botActivation === "false" ? true : false}
                  propertyId={this.props.propertyId}
                  mobile={this.props.mobile}
                  parent_location={this.props.parent_location}
                  parent_referrer={this.props.parent_referrer}
                  selectedProperty={null}
                  open={opened}
                  isBotMode={true}
                ></ChatBot>
              )}
            {opened &&
              !this.state.isOpenBot &&
              this.state.chatBotDetails !== undefined &&
              this.props.botActivation === "false" &&
              !this.state.isWindowBotOpened &&
              this.state.botIntegrationData !== null && (
                <ChatBot
                  botIntegrationData={this.state.chatBotDetails}
                  gid={gid}
                  isValid={this.props.botActivation === "false" ? true : false}
                  propertyId={this.props.propertyId}
                  mobile={this.props.mobile}
                  parent_location={this.props.parent_location}
                  parent_referrer={this.props.parent_referrer}
                  selectedProperty={null}
                  open={false}
                  isBotMode={true}
                ></ChatBot>
              )}
            <div
              className={`msg_window ${
                fullview === "true" ? `msg_window_mobile` : `msg_window`
              } ${this.state.resize === true ? ` resize` : `Window`} ${
                !opened ? `close-messenger-pop` : `open-messenger-pop`
              }`}
              style={{
                visibility: opened ? "visible" : "hidden",
                borderColor:
                  botSettings.colours !== undefined &&
                  botSettings.colours !== null &&
                  botSettings.colours.frameColor !== null
                    ? botSettings.colours.frameColor
                    : "",
              }}
            >
              {opened && messengerTheme !== "" && messengerTheme !== null && (
                <Suspense fallback={<div></div>}>
                  <MsgWindow
                    iid={iid}
                    gid={gid}
                    bearerToken={this.state.bearerToken}
                    isWindowBotOpened={this.state.isWindowBotOpened}
                    isBotActive={this.state.isBotActive}
                    chatBotDetails={this.chatBotDetails.bind(this)}
                    closed={this.closed.bind(this)}
                    integrationData={integrationData}
                    language_state_store={this.state.lStore.LANGUAGE}
                    lang={this.state.lang}
                    isMobile={this.props.mobile}
                    mobile={isFullView === true ? "true" : this.props.mobile}
                    resize={this.state.resize}
                    resize_full={this.resize_full.bind(this)}
                    resize_actual={this.resize_actual.bind(this)}
                    closeWindowBot={this.closeWindowBot.bind(this)}
                    openWindowBot={this.openWindowBot.bind(this)}
                    properties={this.state.properties}
                    nudgeValue={this.state.nudgeValue}
                    removeNudgevalue={() => this.setState({ nudgeValue: null })}
                    parent_location={this.props.parent_location}
                    parent_referrer={this.props.parent_referrer}
                    parent_title={this.props.parent_title}
                    isautoBotopen={this.state.isOpenBot}
                    islanguage_switch={this.state.lStore.ISLANGUAGESWITCH}
                    checkConversation={this.checkConversation.bind()}
                    botConId={this.state.botConId}
                    pageSetting={this.state.pageSetting}
                    messengerTheme={messengerTheme}
                    customStyle={this.props.customStyle}
                  ></MsgWindow>
                </Suspense>
              )}
            </div>
            {!opened && this.props.botData === undefined && (
              <Suspense fallback={<div></div>}>
                <Bubble
                  botSettings={botSettings}
                  fadeIn={animation.bubbleToFadeIn}
                  position={this.props.position}
                  currentNudge={nudges}
                  onOpened={this.opened.bind(this)}
                  hintClosed={this.hintClosed.bind(this)}
                  mobile={mobile}
                  disabledChatbot={disabledChatbot}
                ></Bubble>
              </Suspense>
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ messenger }) => {
  const {
    botActivation,
    propertyId,
    avatarClick,
    groupId,
    chat_started,
    isMessengerMode,
  } = messenger;
  return {
    botActivation,
    propertyId,
    avatarClick,
    groupId,
    chat_started,
    isMessengerMode,
  };
};
export default connect(mapStateToProps, {
  changePropertyId,
  changePropertyName,
  changeDomain,
  changeAvatarClick,
  changeBotActivation,
  changeGroupId,
  changeGroupName,
  changeLevel,
  setIsGroupButton,
  change_Integration_Channel,
  change_Chat_Started,
  changeCurrency,
  changeMode,
})(MsgApp);
